import { createLog } from '@/api/theme'

// 上报错误信息
export const reportErrorMessage = (needData: any, list: any, data: any) => {
  try {
    if (isDataEmpty(needData) || isDataEmpty(needData.code)) {
      const errorMsg = !isDataEmpty(needData)
        ? JSON.stringify(list)
        : JSON.stringify(needData)
      createLog({
        ...data,
        errorMsg: errorMsg,
      })
    }
  } catch (error) {
    console.error(error)
  }
}

// 判断数据是否为空
const isDataEmpty = (data: any) => {
  return data == null || data == undefined || data == ''
}
